<template>
  <div class="outer-wrap" v-if="this.sensorTemp.userConfig" @click="closeMe">
    <div class="sensor-info" @click.stop>
      <!-- Header -->
      <div id="sensor-header" class="noselect c1">
        <h1>{{ !sensor ? "Aggiungi Sensore" : "Modifica Sensore" }}</h1>
        <a @click="closeMe" class="close"></a>
      </div>
      <!-- Wrapper Form -->
      <div class="form-wrap c1">
        <!-- Form Header -->
        <div class="form-header">
          <h5>Dati sensore</h5>
        </div>
        <!-- Tipo -->
        <label for="type">Tipo:</label>
        <select id="type" v-model="sensorTemp.type" class="select-options">
          <option :value="type" v-for="(type, index) in sensorTypes" :key="index">{{ type }}</option>
        </select>
        <!-- EUI -->
        <label for="user">EUI:</label>
        <input
          v-if="true"
          type="text"
          id="user"
          name="user"
          ref="username"
          oninput="this.value = this.value.toUpperCase()"
          :class="[this.validEUI ? 'valid-field' : 'invalid-field']"
          v-model="sensorTemp.eui"
          spellcheck="false"
          :disabled="!editing"
        />
        <h5 v-else class="static-h">{{ sensorTemp.eui }}</h5>
        <!-- Nome -->
        <label for="APPID">Nome:</label>
        <input
          type="text"
          id="loraappid"
          name="APPID"
          :class="[this.validSensorName ? 'valid-field' : 'invalid-field']"
          v-model="sensorTemp.userConfig.name"
          spellcheck="false"
          :disabled="!editing"
        />
        <!-- Disposizione -->
        <label for="disp">Disposizione:</label>
        <select id="disp" v-model="sensorTemp.orientation" :disabled="!defaultData[sensorTemp.type].orientation" class="select-options">
          <option :value="or" v-for="(or, index) in sensorOrientations" :key="index">{{ or }}</option>
        </select>
        <!-- BeamFormat -->
        <label for="beam-format">Beam:</label>
        <input type="checkbox" id="beam-format" v-model="sensorTemp.beamFormat" :disabled="sensorTemp.type != 'tiltmeter'" />
        <!-- Revision -->
        <label for="rev">Versione:</label>
        <select id="rev" v-model="sensorTemp.rev" class="select-options">
          <option :value="rev" v-for="(rev, index) in sensorRevs[sensorTemp.type]" :key="index">{{ rev }}</option>
        </select>
      </div>
      <!-- Settings -->
      <div class="form-wrap c2">
        <div class="form-header">
          <h5>Settings</h5>
        </div>
        <!-- Soglia di Attivazione -->
        <label for="activationTh">Attivazione:</label>
        <input
          type="number"
          id="activationTh"
          :class="[this.validActivationTh ? 'valid-field' : 'invalid-field']"
          v-model.number="sensorTemp.userConfig.activationThreshold"
          spellcheck="false"
          :disabled="!defaultConfig[sensorTemp.type].activationThreshold"
        />
        <!-- Soglia di Allarme -->
        <label for="alert">Allarme:</label>
        <input
          type="number"
          id="alert"
          :class="[this.validThreshold ? 'valid-field' : 'invalid-field']"
          v-model.number="sensorTemp.userConfig.threshold"
          spellcheck="false"
          :disabled="!editing || !defaultConfig[sensorTemp.type].threshold"
        />
        <!-- SR -->
        <label for="samplerate">Sample Rate:</label>
        <select
          id="samplerate"
          v-model.number="sensorTemp.userConfig.sampleRate"
          class="select-options"
          :disabled="!availableConfig[sensorTemp.type].sampleRate"
        >
          <option :value="sr" v-for="(sr, index) in availableConfig[sensorTemp.type].sampleRate" :key="index">
            {{ sr + " " + availableConfig[sensorTemp.type].timeUnit }}
          </option>
        </select>
        <!-- Risoluzione -->
        <label for="ressolution">Risoluzione:</label>
        <select
          id="resolution"
          v-model.number="sensorTemp.userConfig.resolution"
          class="select-options"
          :disabled="!availableConfig[sensorTemp.type].resolution || sensorTemp.rev === '1.0'"
        >
          <option :value="type" v-for="(type, index) in availableConfig[sensorTemp.type].resolution" :key="index">
            {{ type + " " + availableConfig[sensorTemp.type].mesUnit }}
          </option>
        </select>
        <!-- Calibrazione -->
        <label for="psw-reset">Calibrazione:</label>
        <transition name="settings">
          <Calibration
            v-if="calibrationEditing"
            :calibration="sensorTemp.calibration"
            @change-calibration="changeCalibration"
            @undo="closeCalib"
          />
        </transition>
        <button
          class="button embed-btn"
          id="calibration"
          type="button"
          @click="calibrationEdit"
          :disabled="!availableConfig[sensorTemp.type].calibration"
          :class="[this.sensor || sensorTemp.calibration ? 'valid-field' : 'invalid-field']"
        >
          {{ sensorTemp.calibration ? "Modifica" : "Inserisci" }}
        </button>
      </div>
      <!-- Footer -->
      <div id="stats" class="form-wrap">
        <div class="form-header">
          <h5>Statistiche</h5>
        </div>
        <div class="stats-container">
          <p>
            Pacchetti Previsti:
            <span class="strong-text">{{ sensorTemp.stats ? sensorTemp.stats.expectedPackets || "N.D." : "N.D." }}</span>
          </p>
          <p>
            Pacchetti Persi: <span class="strong-text">{{ sensorTemp.stats ? sensorTemp.stats.lostPackets || "N.D." : "N.D." }}</span>
          </p>
          <p>
            Packet Loss Ratio:
            <span class="strong-text">{{
              sensorTemp.stats && sensorTemp.stats.expectedPackets > 1
                ? (sensorTemp.stats.lostPackets / sensorTemp.stats.expectedPackets).toFixed(3)
                : "N.D."
            }}</span>
          </p>
          <button
            @click="resetSensorStats"
            class="button embed-btn"
            id="reset-stats"
            type="button"
            :disabled="!sensorTemp.stats || sensorTemp.stats.expectedPackets == 0"
          >
            RESET
          </button>
        </div>
      </div>
      <div id="footer">
        <div class="footer-btn">
          <button v-if="this.sensor" type="button" class="button c1" @click="deleteSensor">Elimina Sensore</button>
          <button type="button" class="button c4" @click="closeMe">
            {{ $t("message.undo") }}
          </button>
          <button type="button" class="button save c5" :disabled="!validForm" @click="saveSettings">
            {{ $t("message.saveChanges") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validate from "../../../helpers/validate";
import Calibration from "./Calibration";

export default {
  name: "sensor-info",
  components: {
    Calibration,
  },
  props: {
    sensor: Object, // Quando è presente considero il tutto come un 'modifica cliente',
    newPosition: Object, // Quando inserisco un nuovo sensore gli do la posizione
    newType: String,
    generic: Boolean,
  },
  data() {
    return {
      sensorTemp: {},
      editing: true,
      calibrationEditing: false,
      sensorTypes: ["deck", "tiltmeter", "accelerometer", "crackmeter", "analog-node"],
      sensorOrientations: ["verticale", "orizzontale"],
      sensorRevs: {
        deck: ["1.0", "2.0"],
        tiltmeter: ["1.0", "2.0"],
        accelerometer: ["1.0", "2.0"],
        crackmeter: ["1.0", "2.0"],
      },
      /* Parametri disponibili */
      availableConfig: {
        deck: {
          resolution: [0.012, 0.024],
          mesUnit: "mm",
        },
        tiltmeter: {
          sampleRate: [2, 5, 15, 30],
          mesUnit: "deegress",
          calibration: [1, 0, 0],
          timeUnit: "min",
        },
        accelerometer: {
          sampleRate: [1, 2, 6, 12, 24],
          resolution: [0.25, 0.5, 1],
          mesUnit: "mg",
          timeUnit: "hr",
        },
        crackmeter: {
          mesUnit: "mm",
        },
        "analog-node": {},
      },
      /* Parametri di default */
      defaultConfig: {
        deck: {
          activationThreshold: 0.144,
          resolution: 0.012,
          threshold: 6,
        },
        tiltmeter: {
          sampleRate: 2,
          threshold: 36,
        },
        accelerometer: {
          activationThreshold: 3.125,
          resolution: 0.25,
          sampleRate: 12,
          threshold: 12,
        },
        crackmeter: {
          threshold: 12,
        },
        "analog-node": {
          warmupTime: 12,
          acquisitionTime: 12,
          channels: [
            {
              enabled: false,
              type: "4-20",
              name: "CH.1",
            },
            {
              enabled: false,
              type: "4-20",
              name: "CH.2",
            },
            {
              enabled: false,
              type: "4-20",
              name: "CH.3",
            },
            {
              enabled: false,
              type: "4-20",
              name: "CH.4",
            },
          ],
        },
      },
      /* Caratteristiche di default */
      defaultData: {
        deck: {
          color: "blue",
          orientation: "orizzontale",
          rev: "2.0",
        },
        tiltmeter: {
          color: "green",
          rev: "2.0",
        },
        accelerometer: {
          color: "red",
          rev: "2.0",
        },
        crackmeter: {
          color: "black",
          rev: "1.0",
        },
        "analog-node": {
          color: "red",
          rev: "0",
        },
      },
    };
  },
  methods: {
    /* Carica i valori di default in base al tipo di sensore */
    loadDefaultValues(sensorType) {
      this.$set(this.sensorTemp, "rev", this.defaultData[sensorType].rev);
      this.$set(this.sensorTemp.userConfig, "color", this.defaultData[sensorType].color);
      this.$set(this.sensorTemp.userConfig, "threshold", this.defaultConfig[sensorType].threshold);
      if (this.defaultData[sensorType].orientation) this.$set(this.sensorTemp, "orientation", this.defaultData[sensorType].orientation);
      if (this.defaultConfig[sensorType].sampleRate)
        this.$set(this.sensorTemp.userConfig, "sampleRate", this.defaultConfig[sensorType].sampleRate);
      if (this.defaultConfig[sensorType].resolution)
        this.$set(this.sensorTemp.userConfig, "resolution", this.defaultConfig[sensorType].resolution);
      if (this.defaultConfig[sensorType].activationThreshold)
        this.$set(this.sensorTemp.userConfig, "activationThreshold", this.defaultConfig[sensorType].activationThreshold);
      else this.$set(this.sensorTemp.userConfig, "activationThreshold", null);
      /* Nodo */
      if (this.defaultConfig[sensorType].channels)
        this.$set(this.sensorTemp.userConfig, "channels", this.defaultConfig[sensorType].channels);
      if (this.defaultConfig[sensorType].warmupTime)
        this.$set(this.sensorTemp.userConfig, "warmupTime", this.defaultConfig[sensorType].warmupTime);
      if (this.defaultConfig[sensorType].acquisitionTime)
        this.$set(this.sensorTemp.userConfig, "acquisitionTime", this.defaultConfig[sensorType].acquisitionTime);
    },
    saveSettings() {
      if (this.sensor) {
        // Sto modificando un sensore esistente
        this.updateSensor();
      } else {
        // Sto inserendo un nuovo sensore
        this.insertNewSensor();
      }
    },
    deleteSensor() {
      if (confirm("Eliminare il sensore ed i relativi dati? Azione irreversibile!")) {
        this.$emit("delete-sensor", this.sensor.eui);
        this.closeMe();
      }
    },
    updateSensor() {
      delete this.sensorTemp.stats; // non voglio inviare stats al server
      delete this.sensorTemp.groups; // non voglio inviare groups al server
      delete this.sensorTemp.lastTX; // non voglio inviare stats al server
      this.$emit("update-sensor", this.sensor.eui, this.sensorTemp);
      this.closeMe();
    },
    resetSensorStats() {
      this.$emit("reset-sensor-stats", this.sensorTemp.eui);
    },
    insertNewSensor() {
      this.$emit("add-sensor", this.sensorTemp);
      this.closeMe();
    },
    closeMe() {
      this.$emit("close");
    },
    /* Calibration Modal */
    changeCalibration(newCalibration) {
      this.$set(this.sensorTemp, "calibration", newCalibration);
      this.calibrationEditing = false;
    },
    closeCalib() {
      this.calibrationEditing = false;
    },
    calibrationEdit() {
      this.calibrationEditing = true;
    },
  },
  mounted() {
    if (this.sensor) {
      this.sensorTemp = JSON.parse(JSON.stringify(this.sensor)); // Deep Copy
    } else {
      this.$set(this.sensorTemp, "userConfig", {});
      this.$set(this.sensorTemp, "eui", "C0EE40000101");
      this.$set(this.sensorTemp, "bridgeSpan", this.newPosition ? this.newPosition.bridgeSpan : null);
      this.$set(this.sensorTemp, "bridgeSide", this.newPosition ? this.newPosition.bridgeSide : null);
      this.$set(this.sensorTemp, "type", this.newType);
      this.$set(this.sensorTemp, "position", {});
    }
  },
  computed: {
    /* Validation */
    validEUI() {
      return validate.validateEUI(this.sensorTemp.eui);
    },
    validSensorName() {
      return validate.validateSensorName(this.sensorTemp.userConfig.name);
    },
    validThreshold() {
      return !isNaN(this.sensorTemp.userConfig.threshold) || !this.defaultConfig[this.sensorTemp.type].threshold;
    },
    validActivationTh() {
      return !this.defaultConfig[this.sensorTemp.type].activationThreshold || !isNaN(this.sensorTemp.userConfig.activationThreshold);
    },
    validForm() {
      return this.validEUI && this.validSensorName && this.validThreshold && this.validActivationTh;
    },
  },
  watch: {
    sensor: {
      handler(newValue) {
        this.sensorTemp = JSON.parse(JSON.stringify(newValue)); // Deep Copy
      },
      deep: true,
    },
    "sensorTemp.type": function (newValue, oldValue) {
      if (oldValue || !this.sensor) {
        this.loadDefaultValues(newValue);
      }
      this.firstSensorValue = false;
    },
  },
};
</script>
<style scoped>
* {
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  color: white;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  -khtml-user-select: text; /* Konqueror HTML */
  -moz-user-select: text; /* Old versions of Firefox */
  -ms-user-select: text; /* Internet Explorer/Edge */
  user-select: text; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}
.dark-overlay {
  background-color: rgba(0, 0, 0, 0.27);
  width: 100%;
  height: 100%;
  position: absolute;
}
body {
  background-color: white !important;
}
h1 {
  font-size: 1em;
}
h5 {
  margin: 0;
  font-weight: 700;
}
p {
  font-size: 0.8em;
  color: rgb(198, 198, 198);
}
.horiz-divider {
  height: 1px;
  background-color: rgb(80, 84, 105);
  margin: 0 30px 0 30px;
  grid-column-start: 1;
  grid-column-end: 3;
  align-self: end;
}
.sensor-info {
  width: 40vw;
  /* height: 40vh; */
  min-width: 840px;
  /* min-height: 560px; */
  max-width: 940px;
  top: 22vh;
  position: absolute;
  left: auto;
  grid-template-columns: 50% 50%;
  /* grid-template-rows: 11% 44% 21% 11% 14%; */
  border-radius: 10px;
  overflow: hidden;
  display: grid;
  background-color: rgb(45, 48, 65);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
}
#footer {
  background-color: rgb(45, 48, 65);
  border-top: solid 0.8px gray;
  height: fit-content;
  padding: 10px 0;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row: 4;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 2;
  -webkit-box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
  -moz-box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 1px -8px 10px 0px rgba(0, 0, 0, 0.4);
}

.close {
  align-self: center;
  cursor: pointer;
  right: 2%;
  width: 3%;
}
.outer-wrap {
  top: 0;
  left: 0;
  z-index: 16;
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.form-wrap {
  width: 100%;
  text-align: left;
  display: grid;
  padding: 20px 30px;
  box-sizing: border-box;
  grid-row: 2;
  grid-template-rows: 60px repeat(5, 38px);
  height: fit-content;
}
.side-form-wrap {
  width: 100%;
  text-align: left;
  display: grid;
  padding: 40px;
  box-sizing: border-box;
  grid-row: 2;
  grid-template-rows: 60px repeat(5, 32px);
}
.mails-container {
  height: 100%;
  grid-column-start: 1;
  grid-column-end: 3;
  border-radius: 5px;
  overflow-y: scroll;
  overflow-x: hidden;
  background: rgb(22, 25, 35);
  display: grid;
}

.mails-container > h5 {
  justify-self: center;
  align-self: center;
  font-style: italic;
}

.mail {
  height: 60px;
  width: 100%;
  display: grid;
  grid-template-columns: 80% 20%;
  grid-template-rows: 50% 50%;
  padding: 10px;
  box-sizing: border-box;
}

.mail > p {
  margin: 0;
  font-size: 0.65em;
  color: white;
  align-items: center;
}

div.mail:nth-child(even) {
  background: rgba(45, 48, 65, 0.6);
}

div.mail:nth-child(odd) {
  background: rgb(32, 34, 47);
}

.form-header {
  width: 100%;
  border-bottom: solid 1px rgb(80, 84, 105);
  grid-column-start: 1;
  grid-column-end: 3;
  margin-bottom: 20px;
}

#sensor-header {
  background-color: rgb(45, 48, 65);
  height: fit-content;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row: 1;
  z-index: 11;
  display: flex;
  align-items: center;
  padding-left: 1.2vw;
  border-bottom: solid 2px white;
}
.form-wrap > label {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 0.7em;
  font-weight: 700;
  grid-column: 1;
  text-align: right;
  align-self: center;
  color: rgb(150, 153, 162);
}
.form-wrap > input {
  font-size: 0.7em;
  border-radius: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 10px;
  padding-left: 5px;
  grid-column: 2;
  outline-width: 0;
  outline: none !important;
  color: white;
  background-color: rgb(32, 34, 47) !important;
}
input[type="checkbox"] {
  align-self: center;
}

.static-h {
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 10px;
  padding-left: 5px;
}

.buttons-container {
  display: grid;
  height: 30px;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-template-columns: 25% 20% 25% 5% 25%;
  margin-top: 35px;
}
.buttons-container > button {
  font-weight: 700;
  outline-width: 0;
  outline: none !important;
  color: white;
  border-radius: 10px;
  border: solid 2px white;
  background-color: rgb(80, 84, 105);
}
/* Statistiche sensore */
#stats {
  grid-column: 1/3;
  grid-row: 3;
  text-align: left;
  margin: 0 auto;
  grid-template-rows: auto;
}
.stats-container {
  display: flex;
  justify-content: space-around;
  grid-column: 1/3;
  align-items: center;
}
.stats-container > p {
  color: white;
  margin: 0;
}
.strong-text {
  font-weight: 800;
}
#reset-stats {
  margin: 0;
  padding: 5px;
}
/* Control Buttons */
.footer-btn {
  display: grid;
  grid-template-columns: repeat(5, 20%);
  width: 100%;
  padding: 0 40px 0 40px;
}
.button {
  width: fit-content;
  font-size: 0.8em;
  padding: 2%;
  line-height: 100%;
  margin: auto;
  font-weight: 600;
  margin-right: 20px;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 2px white;
  border-radius: 7px;
  white-space: nowrap;
  transition: transform 0.1s linear;
}

.button:active {
  background-color: rgb(47, 112, 177);
  transform: translateY(1px);
}
.button:disabled {
  background-color: grey;
}
.button:disabled:hover {
  background-color: grey;
}
.embed-btn {
  width: auto;
  box-sizing: border-box;
  border: solid 1.5px grey;
  border-radius: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 10px;
  margin-right: 0px;
  padding-left: 5px;
  grid-column: 2;
  outline-width: 0;
  line-height: 1em;
  outline: none !important;
  color: white;
  background-color: rgb(32, 34, 47);
}
/* .buttons-container > #reset{
	grid-column: 1;
}
.buttons-container > #edit{
	grid-column: 3;
}*/
.buttons-container > #save {
  background-color: rgb(21, 146, 230);
}
.select-options {
  border-width: 0px;
  font-size: 0.7em;
  border-radius: 5px;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 10px;
  padding-left: 5px;
  grid-column: 2;
  outline-width: 0;
  outline: none !important;
  color: white;
  background-color: rgb(32, 34, 47);
}
/* .select-options:disabled+label{
  color: rgba(128, 128, 128, 0.39)
} */
.select-options:disabled {
  background-color: rgba(128, 128, 128, 0.39);
}

input[type="text"]:disabled {
  background-color: rgba(128, 128, 128, 0.39) !important;
}

.valid-field {
  border: solid 1.2px green;
}
.invalid-field {
  border: solid 1.2px red;
}
.static-field {
  background-color: initial !important;
}
.form-wrap > input:disabled {
  border-color: transparent;
}

.form-wrap > button:disabled {
  border-color: transparent;
}

::-webkit-scrollbar {
  width: 0.3em;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(80, 84, 105);
  outline: 1px solid slategrey;
  border-radius: 10px;
}
</style>
